import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastMessageOptions, MessageService } from 'primeng/api';
import { ToastPositionKeys } from '../models/messages-keys.enum';
import { catchError, Observable, throwError } from 'rxjs';
import { log } from "../../shared/log";
import { AuthService } from "../auth/services/auth.service";

export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const messageService = inject(MessageService);

  return next(req).pipe(
    catchError((httpError: HttpErrorResponse) => {
      if (httpError.status === 0) {
        const msg: ToastMessageOptions = {
          key: ToastPositionKeys.TOP_CENTER,
          summary: 'Error',
          detail: `Request failed! Couldn't get a response from the server.`,
          severity: 'error',
          life: 10000,
        };
        messageService.clear(ToastPositionKeys.TOP_CENTER);
        messageService.add(msg);
      }
      if (httpError.error?.message === 'Failed to fetch' && req.url.includes('self/')) {
        const authService = inject(AuthService);
        authService.clearLocalUserData();
      }
      log.error('Intercepted error:', httpError);
      return throwError(() => httpError);
    })
  );
};
